import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const BreveteFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='BREVETE' htmlFor='input-brevete' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='brevete'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-brevete'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(BreveteFormGroup)
